@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.button {
    composes: roundButton from "../../styles/buttons.module.scss";

    @include breakpoint.breakpoint(layout.$belowMedium) {
        // Adding !important to bust through CSS Module composes weirdness
        display: block !important;
    }
}
